import script from "./withAdminLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./withAdminLayout.vue?vue&type=script&setup=true&lang=js"

import "./withAdminLayout.vue?vue&type=style&index=0&id=16fd3459&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16fd3459"]])

export default __exports__